import * as React from 'react';
export function usePickerOwnerState(parameters) {
  var props = parameters.props,
    pickerValueResponse = parameters.pickerValueResponse;
  return React.useMemo(function () {
    var _props$disabled, _props$readOnly;
    return {
      value: pickerValueResponse.viewProps.value,
      open: pickerValueResponse.open,
      disabled: (_props$disabled = props.disabled) !== null && _props$disabled !== void 0 ? _props$disabled : false,
      readOnly: (_props$readOnly = props.readOnly) !== null && _props$readOnly !== void 0 ? _props$readOnly : false
    };
  }, [pickerValueResponse.viewProps.value, pickerValueResponse.open, props.disabled, props.readOnly]);
}